import { css } from '@emotion/react'
import { Button, HFlow, VFlow } from 'bold-ui'
import { Box } from 'components/Box'
import { FormRenderProps, SubmitButton } from 'components/form'
import { DateRangeField } from 'components/form/field/daterange/DateRangeField'
import { useConfiguracoes } from 'hooks/configuracoes/useConfiguracoes'
import { useServerTime } from 'hooks/useServerTime'
import { toDate } from 'util/date/formatDate'

import {
  AssinaturaEletronicaAtendTableFilterModel,
  metaFilterAssinaturaEletronica,
} from '../model-assinaturaEletronicaAtend'

type HandleSubmit = FormRenderProps<AssinaturaEletronicaAtendTableFilterModel>['handleSubmit']

export interface AssinaturaEletronicaAtendTableFilterPopperProps {
  onSubmit: HandleSubmit
  onClose: () => void
}

export default function AssinaturaEletronicaAtendTableFilterPopper(
  props: AssinaturaEletronicaAtendTableFilterPopperProps
) {
  const { onSubmit, onClose } = props

  const { getServerTimeNow } = useServerTime()
  const serverTime = getServerTimeNow()
  const { configuracoes } = useConfiguracoes()
  const minDate = toDate(configuracoes.dataAtivacaoAssinaturaRegistros) ?? undefined

  const handleSubmit = (event?: React.SyntheticEvent<HTMLFormElement>) => {
    onSubmit(event)
    onClose()
  }

  return (
    <Box
      style={css`
        width: 34rem;
      `}
    >
      <VFlow>
        <DateRangeField
          name={metaFilterAssinaturaEletronica.periodo}
          label='Período'
          required
          minDate={minDate}
          maxDate={serverTime}
        />
        <HFlow hSpacing={0.5} justifyContent='flex-end'>
          <Button onClick={onClose} size='small' skin='outline' kind='normal'>
            Fechar
          </Button>
          <SubmitButton size='small' handleSubmit={handleSubmit}>
            Filtrar
          </SubmitButton>
        </HFlow>
      </VFlow>
    </Box>
  )
}
